export const CHECKBOX_TRUE_VALUE_BY_NUMBER = 1;
export const CHECKBOX_FALSE_VALUE_BY_NUMBER = 0;
export const CHECKBOX_TRUE_VALUE = true;
export const CHECKBOX_FALSE_VALUE = false;
